import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useRootSelector } from '@/hooks/selector.hook';
import { sideBarItem } from './Sidebar/constants';

export default function Breadcrumb() {
  const breadcrumbItems = useRootSelector((state) => state.breadcrumb.items);

  if (breadcrumbItems.length === 0) {
    return null;
  }

  const getIconByTitle = (title: string) => {
    const match = sideBarItem.find((s) => s.label === title);
    return match ? match.icon : null;
  };

  return (
    <nav className="flex items-center gap-[0.8rem] text-[1.4rem]" aria-label="Breadcrumb">
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;
        const isSecondToLast = index === breadcrumbItems.length - 2;
        const isFirst = index === 0;
        const IconComponent = isFirst ? getIconByTitle(item.title) : null;

        return (
          <div key={index} className="flex items-center gap-[0.8rem]">
            {item.link && !isLast ? (
              <Link
                to={item.link}
                className="sub-text text-[2rem] font-medium hover:text-interactive transition-colors duration-200 flex items-center gap-[0.6rem]"
              >
                {isFirst && IconComponent && <IconComponent className="!h-[2rem] !w-[2rem]" />}
                {item.title}
              </Link>
            ) : (
              <span
                className={`font-medium text-[2rem] flex items-center gap-[0.6rem] ${isLast ? 'text-interactive' : 'sub-text'}`}
              >
                {isFirst && IconComponent && <IconComponent className="!h-[2rem] !w-[2rem]" />}
                {item.title}
              </span>
            )}
            {!isLast && (
              <ChevronRight
                className={`w-[1.6rem] h-[1.6rem] ${isSecondToLast ? 'text-interactive' : 'sub-text'}`}
              />
            )}
          </div>
        );
      })}
    </nav>
  );
}
